import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import BreadcrumbsCustom from 'src/components/common/BreadcrumbsCustom';
import BtnGradient from 'src/components/common/button/BtnGradient';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import View from 'src/components/settings/users/View';
import ViewHistory from 'src/components/settings/users/ViewHistory';
import { postAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';

const breadcrumbsDefine = [
  {
    to: '/user/index',
    label: 'ユーザー',
  },
  {
    label: '詳細',
  },
];

const UserView = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const patientid = searchParams.get('id');
  const token = getToken();
  const [user, setUser] = useState(null);
  const [logs, setLogs] = useState(null);

  const getUser = () => {
    try {
      postAPI(`/auth/user-detail?token=${token}`, {
        id: patientid,
      }).then((res) => {
        if (res && res.code === 200) {
          setUser(res.data.user);
          setLogs(res.data.logs);
        } else {
          navigate('/user/index');
        }
      });
    } catch (error) {
      navigate('/user/index');
      console.error('Failed to fetch data:', error);
      return;
    }
  };

  useEffect(() => {
    getUser();
    // eslint-disable-next-line
  }, []);

  const handleUpdateClick = () => {
    navigate(`/user/edit?id=${patientid}`);
  };

  const handleCancel = () => {
    navigate(`/user/index`);
  };

  return (
    <>
      <BreadcrumbsCustom breadcrumbs={breadcrumbsDefine} />
      <Stack direction={'row'} spacing={'20px'}>
        <Stack width={'470px'}>
          <Typography
            fontSize={'20px'}
            fontWeight={500}
            color={'primary.dark'}
            mt={'18px'}
            mb={'16px'}
          >
            詳細
          </Typography>
          <Stack direction={'row'} spacing={'20px'} width={'auto'}>
            {user && <View user={user} />}
          </Stack>
          <Stack direction={'row'} justifyContent={'space-between'} mt={'32px'}>
            <Stack direction={'row'} spacing={'8px'}>
              <BtnOutlineGradient
                text='キャンセル'
                handleButtonClick={handleCancel}
              />
              <BtnGradient text='更新' handleButtonClick={handleUpdateClick} />
            </Stack>
          </Stack>
        </Stack>
        <Stack flex={1}>
          <Typography
            fontSize={'20px'}
            fontWeight={500}
            color={'primary.dark'}
            mt={'18px'}
            mb={'16px'}
          >
            履歴
          </Typography>
          <Stack
            direction={'row'}
            spacing={'20px'}
            width={'100%'}
            sx={{
              '& .simplebar-track.simplebar-vertical .simplebar-scrollbar:before':
                { backgroundColor: '#CCD1D9' },
            }}
          >
            <SimpleBar style={{ height: '564px', width: '100%' }}>
              <ViewHistory logs={logs} />
            </SimpleBar>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};

export default UserView;
